import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const LogoutMenuItem = ({ handleLogout }) => (
  <Dropdown.Item
    className="aridhia-logout-menu-item"
    title=""
    onClick={handleLogout}
    selected={false}
  >
    <Icon name="sign out" />
    <FormattedMessage id="header.sign.out" />
  </Dropdown.Item>
);

export default LogoutMenuItem;
